<script lang="ts">
    import { onMount } from 'svelte'
    import {type SheetHomeTeam, type SheetMatch, type SheetVisitingTeam} from './src/types';

    export let match:SheetMatch;

    let homePlayer : string;

    let visitingPlayer : string;

    export let visitingTeam : SheetVisitingTeam;

    export let homeTeam : SheetHomeTeam;

    export let homePlayers : string[];

    export let visitingPlayers : string[];

    export let updateDoubles: () => void = () => {};

    export let readonly:boolean = false;

    export let incomplete: boolean = false;

    let getPlayerName = (team:any,letter:string):string => {
        if (letter) {
            return team.hasOwnProperty(letter) ? team[letter]?.name : '';
        }
        return '';
    }

    onMount(() => {
        console.log('match',match);
        console.log('homeTeam',homeTeam);
        console.log('visitingteam',visitingTeam)
        console.log('hometeam',homeTeam)
        console.log('homeplayers',homePlayers)
        console.log('visitingPlayers',visitingPlayers)
        homePlayer = getPlayerName(homeTeam,homePlayers[0])+' - '+getPlayerName(homeTeam,homePlayers[1]);            
        visitingPlayer = getPlayerName(visitingTeam,visitingPlayers[0])+' - '+getPlayerName(visitingTeam,visitingPlayers[1]);
    });

    let isNullOrEmpty = (s : string) => {
        return s === undefined || s === null || s.length == 0;
    }

    let incompleteHome = (team : SheetHomeTeam) => {
        let count = 0
        count += isNullOrEmpty(homeTeam.A.name) ? 0 : 1;
        count += isNullOrEmpty(homeTeam.B.name) ? 0 : 1;
        count += isNullOrEmpty(homeTeam.C.name) ? 0 : 1;
        count += isNullOrEmpty(homeTeam.D.name) ? 0 : 1;        
        return count < 2;
    }
    let incompleteVisiting = (team: SheetVisitingTeam) => {
        let count = 0;
        count += isNullOrEmpty(visitingTeam.X.name) ? 0 : 1;
        count += isNullOrEmpty(visitingTeam.Y.name) ? 0 : 1;
        count += isNullOrEmpty(visitingTeam.Z.name) ? 0 : 1;
        count += isNullOrEmpty(visitingTeam.W.name) ? 0 : 1;
        return count < 2;
    }

</script>

{#if match && match.home && match.visiting && match.home.length > 0 && match.visiting.length > 0}
    {#if readonly}
        <tr>
            <td style="text-align:center">{homePlayer}</td><td></td>
            <td>{match.home[0]}</td>
            <td>{match.home[1]}</td>
            <td>{match.home[2]}</td>
            <td>{match.home[3]}</td>
            <td>{match.home[4]}</td>
            <td>{match.score_home}</td>
            <td style="text-align:center">{visitingPlayer}</td>
            <td>{match.visiting[0]}</td>
            <td>{match.visiting[1]}</td>
            <td>{match.visiting[2]}</td>
            <td>{match.visiting[3]}</td>
            <td>{match.visiting[4]}</td>
            <td>{match.score_visiting}</td>
        </tr>
    {:else}
        <tr>
            <td>
                <select bind:value={homePlayers[0]} style="display:inline" on:change={updateDoubles} disabled={incompleteHome(homeTeam)}>            
                    <option value=""></option>          
                    <option value="A">A - {homeTeam.A.name}</option>
                    <option value="B">B - {homeTeam.B.name}</option>
                    <option value="C">C - {homeTeam.C.name}</option>
                    <option value="D">D - {homeTeam.D.name}</option>
                </select>
                <select bind:value={homePlayers[1]} style="display:inline" on:change={updateDoubles} disabled={incompleteHome(homeTeam)}>  
                    <option value=""></option>          
                    <option value="A">A - {homeTeam.A.name}</option>
                    <option value="B">B - {homeTeam.B.name}</option>
                    <option value="C">C - {homeTeam.C.name}</option>
                    <option value="D">D - {homeTeam.D.name}</option>
                </select>        
            </td><td></td>
                <td><input type="number" bind:value={match.home[0]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[1]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[2]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[3]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[4]} disabled={incomplete}/></td>
                <td>{match.score_home}</td>
            <td>
                <select bind:value={visitingPlayers[0]} style="display:inline" on:change={updateDoubles} disabled={incompleteVisiting(visitingTeam)}>            
                    <option value=""></option>          
                    <option value="X">x - {visitingTeam.X.name}</option>
                    <option value="Y">Y - {visitingTeam.Y.name}</option>
                    <option value="Z">Z - {visitingTeam.Z.name}</option>
                    <option value="W">W - {visitingTeam.W.name}</option>
                </select>
                <select bind:value={visitingPlayers[1]} style="display:inline" on:change={updateDoubles} disabled={incompleteVisiting(visitingTeam)}>  
                    <option value=""></option>          
                    <option value="X">X - {visitingTeam.X.name}</option>
                    <option value="Y">Y - {visitingTeam.Y.name}</option>
                    <option value="Z">Z - {visitingTeam.Z.name}</option>
                    <option value="W">W - {visitingTeam.W.name}</option>
                </select>    
            </td>
                <td><input type="number" bind:value={match.visiting[0]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[1]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[2]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[3]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[4]} disabled={incomplete}/></td>
            <td>{match.score_visiting}</td>
        </tr>
    {/if}
{/if}
